import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IIsBankPaymentFacilitatorRequestType {
    merchantId: any;
}

async function IsBankPaymentFacilitatorRequest(
    data: IIsBankPaymentFacilitatorRequestType
): Promise<any> {
    try {
        const formData = new FormData();
        formData.append("merchantId", data.merchantId);

        return (await axiosInstance.post("/Merchant/IsBankCreatePaymentFacilitator", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useIsBankPaymentFacilitatorRequest() {
    return useMutation<any, Error, IIsBankPaymentFacilitatorRequestType>(
        (variables) => IsBankPaymentFacilitatorRequest(variables)
    );
}
